module.exports = __webpack_public_path__ + "img/direction.39f2b709.svg";